import axios from "axios";

const authConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const enteFunciones = {
  obtenerEntesConformadores: async () => {
    try {
      const response = await axios.get("/api/ente/listall", authConfig());
      console.log("Lista de ente conformadores:", response.data);
      return response.data.entesConformadores || [];
    } catch (error) {
      console.error(
        "Error al obtener la lista de ente conformadores:",
        error.response?.data || error
      );
      return [];
    }
  },

  obtenerJefes: async () => {
    try {
      const response = await axios.get("/api/jefe/listall", authConfig());
      return response.data.jefes || [];
    } catch (error) {
      console.error("Error al obtener la lista de jefes inmediatos:", error);
      return [];
    }
  },
};

export default enteFunciones;